import { render } from "./OrthoPartnersDetail.vue?vue&type=template&id=67b9db09"
import script from "./OrthoPartnersDetail.vue?vue&type=script&lang=js"
export * from "./OrthoPartnersDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__